import React, { useState } from "react";
import "./style.scss";
import { NavLink, useLocation } from "react-router-dom";
import { ReactComponent as Home } from "../../asset/icons/home_gray.svg";
import { ReactComponent as HomeBlue } from "../../asset/icons/home_blue.svg";
import { ReactComponent as Star } from "../../asset/icons/star_gray.svg";
import { ReactComponent as StarBlue } from "../../asset/icons/star_blue.svg";
import { ReactComponent as Time } from "../../asset/icons/time_gray.svg";
import { ReactComponent as TimeBlue } from "../../asset/icons/time_blue.svg";
import { ReactComponent as Rate } from "../../asset/icons/rate_header.svg";
import ScanImage from "../../asset/image/scan.png";
import DBModal from "./../../component/global/DBModal/index";
import { useTranslation } from "react-i18next";
import { DBButton } from "../../DBComponents/DBButton";
import { useNavigate } from "react-router-dom";
import useDetectKeyboardOpen from "use-detect-keyboard-open";

export default function MainNavbar() {
    const isKeyboardOpen = useDetectKeyboardOpen();

    let location = useLocation();
    const { t, i18n } = useTranslation();
    const [exitModal, setExitModal] = useState(false);
    const navigate = useNavigate();
    const isAuthPage = location.pathname === "/auth";
    const isPublicShare = location.pathname.includes("/content/share/");
    const isInsideFeedback = () => {
        const url = window.location.pathname;
        const urlArray = url.split("/");
        if (urlArray[2] === "feedback") {
            return true;
        }
        return false;
    };

    if (isAuthPage || isPublicShare) {
        return null;
    }

    return (
        <React.Fragment>
            <div
                className="navbar-container"
                style={{ visibility: isKeyboardOpen ? "hidden" : "visible" }}
            >
                <DBModal
                    show={exitModal}
                    minWidth={400}
                    onHide={() => setExitModal(false)}
                >
                    <DBModal.Header>
                        <b style={{ padding: 16 }}>
                            {t("exit.from.product.header")}
                        </b>
                    </DBModal.Header>
                    <DBModal.Content>
                        <p style={{ marginTop: 16 }}>
                            {t("exit.from.product")}
                        </p>
                        <div className="button-con">
                            <DBButton
                                onClick={() => {
                                    navigate("/");
                                    setExitModal(false);
                                }}
                            >
                                {t("caption.yes")}
                            </DBButton>
                            <DBButton
                                outlined={true}
                                onClick={() => setExitModal(false)}
                            >
                                {t("caption.no")}
                            </DBButton>
                        </div>
                    </DBModal.Content>
                </DBModal>
                <ul>
                    {/* <li>
                        <NavLink to="/">
                            <Rate />
                        </NavLink>
                    </li> */}
                    <li>
                        <NavLink
                            to={"/" + sessionStorage.getItem("product-id")}
                            onClick={(e) =>
                                !sessionStorage.getItem("product-id") &&
                                e.preventDefault()
                            }
                            style={{
                                opacity: sessionStorage.getItem("product-id")
                                    ? 1
                                    : 0.5,
                            }}
                        >
                            {location.pathname ===
                            "/" + sessionStorage.getItem("product-id") ? (
                                <TimeBlue />
                            ) : (
                                <Time />
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/scanner">
                            <img src={ScanImage} alt="" />
                        </NavLink>
                    </li>
                    {/* <li>
                        <NavLink to="/">
                            {location.pathname === "/bests" ? (
                                <StarBlue />
                            ) : (
                                <Star />
                            )}
                        </NavLink>
                    </li> */}
                    <li>
                        <button
                            onClick={() => {
                                if (isInsideFeedback()) {
                                    setExitModal(true);
                                } else {
                                    navigate("/");
                                }
                            }}
                        >
                            {location.pathname === "/" ? (
                                <HomeBlue />
                            ) : (
                                <Home />
                            )}
                        </button>
                    </li>
                </ul>
            </div>
        </React.Fragment>
    );
}
